import Clarity from '@microsoft/clarity';
import * as React from 'react';
import { useLocation } from 'react-router-dom';

import { getOptionalEnv } from '../lib/getEnv';
import { useAuthState } from '../providers/AuthProvider';

const ClarityRouteTracker = () => {
  const location = useLocation();
  const { user, session } = useAuthState();
  const clarityProjectId = getOptionalEnv('VITE_CLARITY_PROJECT_ID');

  React.useEffect(() => {
    // Identify user on route changes if authenticated and Clarity is initialized
    if (clarityProjectId && user && session) {
      Clarity.identify(user.id, session.id, location.pathname, user.firstName ?? user.lastName ?? undefined);
    }
  }, [location.pathname, user, session, clarityProjectId]);

  return null;
};

export default ClarityRouteTracker;
